import styles from "../creditreport.module.css";

const KpiCard = ({ iconBg, icon, value, label, delta, deltaType }) => {
    return (<div className={styles.kpiCard}>
        <div className={styles.kpiIcon} style={{ background: iconBg }}>{icon}</div>
        <p className={styles.kpiValue}>{value}</p>
        <p className={styles.kpiLabel}>{label}</p>
        <span className={`${styles.kpiDelta} ${deltaType === "up" ? styles.deltaUp : styles.deltaFlat}`}>{delta}</span>
    </div>);
}

export default KpiCard;